import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Set your API base URL
const BASE_URL = process.env.REACT_APP_BASE_URL;


// Thunks for async actions
export const addContact = createAsyncThunk(
    'contacts/addContact',
    async (contactData, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${BASE_URL}/contact/add`, contactData);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

export const getContacts = createAsyncThunk(
    'contacts/getContacts',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${BASE_URL}/get`);
            return response.data.contactData;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

export const deleteContact = createAsyncThunk(
    'contacts/deleteContact',
    async (contactId, { rejectWithValue }) => {
        try {
            const response = await axios.delete(`${BASE_URL}/delete/${contactId}`);
            return contactId; // return contactId to identify which contact is deleted
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);
